import ReactMarkdownLib, {
  Options as ReactMarkdownProps,
} from 'react-markdown';

/** Cast for React 19 type compatibility with react-markdown. */
const ReactMarkdown =
  ReactMarkdownLib as React.ComponentType<ReactMarkdownProps>;

const LinkRenderer = (props: any) => {
  return (
    <a href={props.href} target="_blank" rel="noreferrer">
      {props.children}
    </a>
  );
};

export function MarkdownContent(props: ReactMarkdownProps) {
  const components = props.components || {};
  if (!components.a) {
    components.a = LinkRenderer;
  }
  return (
    <ReactMarkdown
      {...props}
      components={components}
      allowedElements={['a', 'p', 'em', 'img', 'strong', 'ul', 'ol', 'li']}
    />
  );
}
